<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-12 11:16:15
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-12 13:33:57
 * @FilePath: \Home\Transfor-website\src\views\pc\Community\email.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="Email">
      <div class="Email-W">
        <p>{{ $t("Email.Sign") }}</p>
        <p>{{ $t("Email.We") }}</p>
        <el-form
          :model="dynamicValidateForm"
          :rules="rules"
          class="demo-ruleForm"
          autocomplete="off"
        >
          <el-form-item prop="email">
            <el-input
              v-model="dynamicValidateForm.email"
              placeholder="Enter your email"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('dynamicValidateForm')"
              >Subscribe now</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dynamicValidateForm: {
        domains: [
          {
            value: "",
          },
        ],
        email: "",
      },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            message: "Please input email",
            trigger: "blur",
          },
        ],
      },
    };
  },

  mounted() {},

  methods: {
    // 提交表单验证
    submitForm(formName) {
      // 获取邮箱
      //   let email = this.ruleForm.email;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message.error("成功");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.Email {
  width: 100%;
  background-color: #000000;
  .Email-W {
    width: 554px;
    margin: 0 auto;
    padding: 260px 0 420px 0;
    p:nth-child(1) {
      width: 554px;
      font-size: 70px;
      font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 98px;
    }
    p:nth-child(2) {
      width: 490px;
      font-size: 30px;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 42px;
    }
    .el-input {
      margin-top: 45px;
      .el-form-item::v-deep input {
        width: 480px;
        height: 70px;
        background: rgba(207, 97, 220, 0.10000000149011612);
        border-radius:35px;
        opacity: 1;
        border: 2px solid #cf61dc;
        padding: 24px 30px;
        font-size: 18px;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #cf61dc;
      }
    }
    button {
      width: 480px;
      height: 50px;
      background: rgba(207, 97, 220, 0.10000000149011612);
      border-radius: 35px 35px 35px 35px;
      opacity: 1;
      background: #cf61dc;
      font-size: 18px;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 25px;
      border: none;
      display: inline-block;
    }
  }
}
</style>
